var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-center"},[_c('flight-class-selector',{staticClass:"mb-5",attrs:{"offer":_vm.offer},on:{"select-class":function($event){_vm.categoryClass = $event}}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.selectOffer}},[_vm._v("\n        "+_vm._s(_vm.$t('select'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }